import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M2 4V15C2 16.6875 3.3125 18 5 18H28.5625L22.25 11.75C21.875 11.375 21.875 10.6875 22.25 10.3125C22.625 9.9375 23.3125 9.9375 23.6875 10.3125L31.6875 18.3125C32.0625 18.6875 32.0625 19.375 31.6875 19.75L23.6875 27.75C23.3125 28.125 22.625 28.125 22.25 27.75C21.875 27.375 21.875 26.6875 22.25 26.3125L28.5625 20H5C2.1875 20 0 17.8125 0 15V4C0 3.5 0.4375 3 1 3C1.5 3 2 3.5 2 4Z'],
  name: 'uiArrowTurnDownRight'
} as IconDefinition
